import { Injectable } from '@angular/core';
import { ProductRelated } from '../entities/product-related';
import { BaseTableService } from './base-table.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@mobileia/authentication';

@Injectable({
  providedIn: 'root'
})
export class ProductRelatedService extends BaseTableService<ProductRelated> {

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
    this.basePathUrl = 'admin/product-related';
  }
  
}
